/***
 * @file:æ¥ææ ¼å¼è½¬æ¢æ¹æ³
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import * as moment_ from 'moment';
const moment = moment_;

// å½åæ¶é´ï¼æ åæ ¼å¼ï¼
export function standardDate(date?) {
  return date ? new Date(Number(date)) : new Date();
}

// å½åæ¶é´æ³
export function timestamp(date?) {
  return standardDate(date).getTime();
}

// æ åæ¥ææ ¼å¼è½¬æ¶é´æ³
export function getTimestamp(date?) {
  return date.getTime();
}

// å¹´ææ¥
export function YMD(date?, spl?: string) {
  date = date || standardDate();
  spl = spl || '-';
  return moment(date).format(`YYYY${spl}MM${spl}DD`);
}

// å¹´ææ¥æ¶åç§
export function YMDHMS(date?, spl?: string, H?: boolean) {
  date = date || standardDate();
  spl = spl || '-';
  const hour = H === false ? 'h' : 'H';
  return moment(date).format(`YYYY${spl}MM${spl}DD  ${hour}:mm:ss`);
}

export function Dday(date?) {
  return moment(date).format('dddd'); // ææå
}

export function compareDate(pre, next) {
  const earlier = timestamp(pre) - timestamp(next);
  return earlier >= 0 ? true : false;
}
